import React from 'react';
import { Link as RouterLink, useLocation, Redirect, BrowserRouter as Router } from 'react-router-dom';
import { withStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

// hollywood
import axios from 'axios';

const styles = (theme) => ({
  root: {
    padding: '16px',
  },
});

export class SubscriptionError extends React.PureComponent {
  constructor(...args) {
    super(...args);
    this._logoutTimerID = null;
    this._logoutIntervalID = null;

    const { user, updateUser } = this.props;
    this.state = {
      user,
      updateUser,
      // stripeId: '',
      // stripeUser: '',
      // redirect: false,
      // redirectTo: '/',
    };
  }

  componentDidMount = async () => {};

  renderRedirect = () => {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirectTo} />;
    }
  };

  render() {
    const { classes } = this.props;
    const { user, updateUser } = this.state;
    return (
      <div className={classes.root}>
        <Grid container spacing={4}>
          <Grid item lg={12}>
            <div style={{ marginTop: 250, textAlign: 'center' }}>
            <h3>You have canceled your purchase or there was a problem with your purchase.</h3>
            <p style={{margin: 24}}>Please contact UnderstandingAG support <a href='mailto:support@regenagonline.com'>support@regenagonline.com</a> for assistance</p>
            <RouterLink to="/">
                <Button variant='contained' color='primary'>Continue</Button>
            </RouterLink>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}

SubscriptionError.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  updateUser: PropTypes.func,
};

export default withStyles(styles)(SubscriptionError);
